// Exports
export default {
	"container": "container_kkmiA",
	"menu": "menu_0pMje",
	"content": "content_DDl0A"
};
